<template>
  <div class="ended p-4 space-y-2">
    <!--    <div class="text-center text-gray-400 text-sm">-->
    <!--      Your conversation has ended.-->
    <!--    </div>-->
    <div class="text-center text-gray-400 text-sm">
      <Button
        kind="primary"
        :loading="isButtonDisabled"
        @click="startNewConversation"
        >{{
          t("messengerConversationEnded.startNewConversationButtonText")
        }}</Button
      >
    </div>
  </div>
</template>

<script>
import { defineComponent, ref } from "vue";
import Button from "@/components/Button";
import { useChatConnection } from "@/composables/chatConnection";
import { useI18n } from "vue-i18n";

export default defineComponent({
  name: "MessengerConversationEnded",
  components: {
    Button,
  },
  setup() {
    const { requestStartConversation } = useChatConnection();
    const { t } = useI18n();

    const isButtonDisabled = ref(false);

    const startNewConversation = () => {
      isButtonDisabled.value = true;

      requestStartConversation();
      setTimeout(() => {
        isButtonDisabled.value = false;
      }, 10000);
    };

    return {
      startNewConversation,
      isButtonDisabled,
      t,
    };
  },
});
</script>

<style scoped lang="scss">
@import "@/assets/animation.scss";

.ended {
  @include animation(0, 1s, fade-in);
  box-shadow: rgb(0 0 0 / 8%) 0px 0px 20px 0px;
}
</style>
